import {
  adCustomizersStyle,
  alertStyle as alertOverrideStyle,
  buttonInputStyle,
  crudAdStyle,
  crudAudienceAdStyle,
  underlineLinkStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { adEditorStyle } from './ad-editor-style';

const adEditorFormOverrideStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  ...adCustomizersStyle({ palette, iconFontFamily }),
  ...crudAdStyle({ palette, iconFontFamily }),
  ...crudAudienceAdStyle({ palette, iconFontFamily }),
});

export const adEditorOverrideStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .ad-editor__container, & .adEditor-container, & .ad-editor-form__container, & .crud-audience-ad, & div[data-step-name="audience-campaign-creation-wizard-step3"], & div[data-step-name="audience-adgroup-creation-wizard-step3"]': {
    ...adEditorStyle({ palette }),
    ...adEditorFormOverrideStyle({ palette, iconFontFamily }),
    ...alertOverrideStyle({ palette, iconFontFamily }),
    ...buttonInputStyle({ palette }),
  },
  '@global': {
    '.modal-dialog .modal-content .modal-body .form-group .impression-tracking-url-dialog-content-container': {
      margin: '0 16px',
    },
    '.modal-dialog .modal-content .modal-body .form-group .impression-tracking-url-dialog-content-container .impression-tracking-url-dialog-description': {
      marginBottom: '20px',
    },
    '.modal-dialog .modal-content .modal-body .form-group .impression-tracking-url-dialog-content-container .impression-tracking-url-dialog-textarea-description': {
      marginBottom: '10px',
    },
    '.modal-dialog .modal-content .modal-body .form-group .impression-tracking-url-dialog-content-container .impression-tracking-url-error-message': {
      color: 'red',
    },
  },
});

export const adEditorPanelOverrideStyle = ({ palette = {} }) => ({
  '&.panel, & .panel': {
    '& .panel-title': {
      fontSize: 20,
      fontWeight: '600 !important',
      lineHeight: '27px',
    },
    '& .panel-body .ad-editor-form__container': {
      width: 1200,

      '& div[data-type="AppInstall"], & div[data-type="Text"]': {
        minHeight: 700,
      },

      '& input.btn': {
        marginRight: 8,
      },
      '& ul, & ol': {
        listStyle: 'none',
        paddingLeft: 0,
      },
      '& .ui-tabs .ui-tabs-nav': {
        paddingLeft: 0,
      },
      '& > h5': {
        fontSize: 16,
        lineHeight: '24px',
        fontWeight: 400,
      },
      '& > .row': {
        flexWrap: 'wrap',
      },
    },
    '& .form-group.save-bar.appEditor-save-container': {
      borderTop: '1px solid #EDEBE9',
      bottom: 0,
      margin: '0 -16px',
      padding: '16px',
      position: 'fixed',
      width: '100%',
    },
    '&.ad-editor-panel .panel-body': {
      height: '100%',
      marginBottom: '65px',
      '& .alert > .alert-info-inline': {
        ...underlineLinkStyle({ palette, isGreyBackground: true }),
      },
      ...underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic' }),
    },
    // ad suggestion
    '& .recommended-ad-editor': {
      width: '100%',
      '& .appEditor-save-container': {
        ...buttonInputStyle({ palette }),
      },
    },
  },
  ...adEditorOverrideStyle({ palette }),
});
